import { Section } from '@components/section/Section'
import { SectionTitle } from '@components/section/SectionTitle'
import { CircleCheck, CircleX, UserPlus, UserRound, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DashboardStatistics } from 'types/api'

import { StatTile } from './StatTile'

interface UserActivityProps {
  statistics: DashboardStatistics | undefined
  loading?: boolean
}

const UserActivity = ({ statistics, loading }: UserActivityProps) => {
  const { t } = useTranslation('dashboard')

  return (
    <Section
      title={
        <SectionTitle
          icon={<UserPlus />}
          title={t('statistics.sections.users')}
        />
      }
      defaultActiveKey={['0']}
    >
      {loading ? (
        <div className="h-24 animate-pulse rounded-xl bg-ink/[0.04]" />
      ) : (
        <div className="space-y-5">
          <StatTile
            icon={Users}
            tone="purple"
            to="/admin/users"
            label={t('statistics.allUsers')}
            value={statistics?.all_users_count ?? 0}
          />
          <div className="grid gap-5 sm:grid-cols-3">
            <StatTile
              icon={UserRound}
              tone="blue"
              to="/admin/offers?status=ONGOING"
              label={t('statistics.usersWithOngoingOffers')}
              value={statistics?.users_with_ongoing_offers_count ?? 0}
            />
            <StatTile
              icon={CircleCheck}
              tone="green"
              to="/admin/applications?status=true"
              label={t('statistics.activeApplications')}
              value={statistics?.active_applications_count ?? 0}
            />
            <StatTile
              icon={CircleX}
              tone="red"
              to="/admin/applications?status=false"
              label={t('statistics.inactiveApplications')}
              value={statistics?.inactive_applications_count ?? 0}
            />
          </div>
        </div>
      )}
    </Section>
  )
}

export default UserActivity
